import styled from 'styled-components';

export const PaywallAppStepsStyles = styled.div<{
  stepGetPlanBgUrl: string;
  stepExploreBgUrl: string;
  stepDiveInBgUrl: string;
  staticTheme: 'dark-violet' | 'domination' | 'purple-gradient' | undefined;
}>`
  body.dark & {
    --card-step-label-bg: #9e1fda;
    --card-bg: #803eff12;

    ${({ staticTheme }) =>
      staticTheme === 'dark-violet' &&
      `
      --card-bg: #553573;
    `};
  }

  --card-step-label-bg: #fff;
  --card-bg: #803eff0d;

  ${({ staticTheme }) =>
    staticTheme === 'domination' &&
    `
      --card-step-label-bg: linear-gradient(95.02deg, #D9002F 0%, #7F001C 100%);
    `}

  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0 auto;
  max-width: 500px;
  width: 100%;
  padding: 0 16px;

  .paywall-app-steps-card {
    height: 290px;
    background: var(--card-bg);
    border-radius: 18px;
    padding: 16px;

    &-step {
      padding: 2px 8px;
      background: var(--card-step-label-bg);
      border-radius: 12px;
      width: fit-content;
      margin-bottom: 8px;
      color: var(--text-color-white);

      ${({ staticTheme }) =>
        staticTheme === 'domination' &&
        `
          color: #fff;
          background: linear-gradient(95.02deg, #D9002F 0%, #7F001C 100%);
        `}

      &-label {
        margin: 8px 0;
      }
    }

    // default resources
    &:nth-child(1) {
      background: url(${(props) => props.stepGetPlanBgUrl}),
        url(https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding-white/card-phone-bg.png),
        var(--card-bg);
      background-position:
        bottom center,
        bottom center,
        0 0;
      background-size:
        160px 160px,
        100% 160px,
        100% 100%;
      background-repeat: no-repeat;
    }

    &:nth-child(2) {
      background: url(${(props) => props.stepExploreBgUrl}), var(--card-bg);
      background-position:
        bottom center,
        0 0;
      background-size:
        500px 160px,
        100% 100%;
      background-repeat: no-repeat;
    }

    &:nth-child(3) {
      background: url(${(props) => props.stepDiveInBgUrl}), var(--card-bg);
      background-position:
        bottom center,
        0 0;
      background-size:
        343px 160px,
        100% 100%;
      background-repeat: no-repeat;
    }
  }
`;
